import { buildAdditionalDetailFields, buildNewFieldUpdates, buildRequestedDetailFields, splitPromptAndFieldList, } from './surveyData';
let messageIdCounter = 0;
export function nextChatMessageId() {
    messageIdCounter += 1;
    return `msg-${messageIdCounter}`;
}
export function buildAssistantChatMessage(result, previousData, definition) {
    const promptParts = splitPromptAndFieldList(result.userPrompt);
    const summaryParts = splitPromptAndFieldList(result.summary);
    const fieldLabels = promptParts.fieldLabels.length > 0 ? promptParts.fieldLabels : summaryParts.fieldLabels;
    const promptIntro = promptParts.intro ?? summaryParts.intro;
    return {
        id: nextChatMessageId(),
        role: 'assistant',
        userPrompt: result.userPrompt,
        promptIntro,
        summary: result.summary,
        missingFields: result.missingFields,
        ambiguousFields: result.ambiguousFields,
        additionalDetails: result.additionalDetails,
        additionalDetailFields: buildAdditionalDetailFields(result.additionalDetails, result.missingFields, result.ambiguousFields, definition),
        requestedDetailFields: buildRequestedDetailFields(fieldLabels, definition, result.missingFields, result.ambiguousFields),
        surveyData: result.surveyData,
        fieldUpdates: buildNewFieldUpdates(previousData, result.surveyData, definition),
        debug: result.debug,
    };
}
